import { render } from "./InfoPostDialog.vue?vue&type=template&id=f9c7f0a4&scoped=true"
import script from "./InfoPostDialog.vue?vue&type=script&lang=js"
export * from "./InfoPostDialog.vue?vue&type=script&lang=js"

import "./InfoPostDialog.vue?vue&type=style&index=0&id=f9c7f0a4&scoped=true&lang=css"
import "./InfoPostDialog.vue?vue&type=style&index=1&id=f9c7f0a4&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\bp-kmiyajima\\Documents\\Projects\\noritz-protal\\front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f9c7f0a4"]])

export default __exports__